import { EColorState } from '@/components/IBPayment/interface';
import { Vue, Component } from 'vue-property-decorator';
import { PaymentRequirementsIncomingStatus, PaymentRequirementsOutgoingStatus } from '../../../api/incoming/payment-requirements-incoming.interface';
import { PaymentRequirementsStatusConfigMap } from '../interface';

@Component
export default class PaymentRequirementsStatusConfigs extends Vue {

	readonly paymentRequirementsIncomingStatusConfig:
		PaymentRequirementsStatusConfigMap<PaymentRequirementsIncomingStatus> = {
		[PaymentRequirementsIncomingStatus.ACCEPTED]: {
			color: EColorState.danger
		},
		[PaymentRequirementsIncomingStatus.WITHDRAWN]: {
			color: EColorState.success
		},
		[PaymentRequirementsIncomingStatus.PAID]: {
			color: EColorState.success
		},
		[PaymentRequirementsIncomingStatus.CAPITALIZED_K1]: {
			color: EColorState.danger
		},
		[PaymentRequirementsIncomingStatus.CAPITALIZED_K2]: {
			color: EColorState.danger
		},
		[PaymentRequirementsIncomingStatus.PROCESSING_TIME_EXPIRED]: {
			color: EColorState.info
		},
		[PaymentRequirementsIncomingStatus.DENIED]: {
			color: EColorState.info
		},
		[PaymentRequirementsIncomingStatus.WAITING_PAYMENT_COMPLETE]: {
			color: EColorState.success
		}
	}

	readonly paymentRequirementsOutgoingStatusConfig:
		PaymentRequirementsStatusConfigMap<PaymentRequirementsOutgoingStatus> = {
		[PaymentRequirementsOutgoingStatus.UNDEFINED]: {
			color: EColorState.info
		},
		[PaymentRequirementsOutgoingStatus.CREATED]: {
			color: EColorState.success
		},
		[PaymentRequirementsOutgoingStatus.REMOVED]: {
			color: EColorState.info
		},
		[PaymentRequirementsOutgoingStatus.SENT]: {
			color: EColorState.success
		},
		[PaymentRequirementsOutgoingStatus.REJECTED_BY_BOARD_BANK]: {
			color: EColorState.danger
		},
		[PaymentRequirementsOutgoingStatus.ACCEPTED_BY_BANK_PAYMENTS]: {
			color: EColorState.success
		},
		[PaymentRequirementsOutgoingStatus.CAPITALIZED_K1]: {
			color: EColorState.success
		},
		[PaymentRequirementsOutgoingStatus.CAPITALIZED_K2]: {
			color: EColorState.success
		},
		[PaymentRequirementsOutgoingStatus.PAID]: {
			color: EColorState.success
		},
		[PaymentRequirementsOutgoingStatus.WITHDRAWN]: {
			color: EColorState.info
		},
		[PaymentRequirementsOutgoingStatus.DENIED]: {
			color: EColorState.danger
		},
		[PaymentRequirementsOutgoingStatus.PROCESSING_TIME_EXPIRED]: {
			color: EColorState.danger
		},
	}

}